/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import ContainerBase from '@bingads-webui-component-legacy/grid/containerBase';
var WindowContainer = ContainerBase.extend({
  constructor: function (options) {
    options = _.extend({}, options, {
      el: window
    });
    ContainerBase.prototype.constructor.apply(this, [options].concat(_.rest(arguments)));
  },
  offset: function (element) {
    return $(element).offset();
  }
});
export default WindowContainer;

